import { mutationOptions, queryOptions } from '@tanstack/react-query'
import {
  ApprovalRuleResponse,
  ApprovalRuleType,
} from 'src/models/organizations.models'
import { QueryError } from 'src/queries/network.utils'
import {
  DeleteCardApprovalRuleResponse,
  PostCardApprovalRuleResponse,
  UpsertCardApprovalRuleBody,
} from 'src/queries/organizations/cardApprovalRules/cardApprovalRules.models'
import {
  deleteCardApprovalRule,
  getCardApprovalRule,
  postCardApprovalRule,
} from 'src/queries/organizations/cardApprovalRules/cardApprovalRules.network'
import { orgQueryKeys, queryCacheOptions } from 'src/queries/queries.constants'

export const orgCardApprovalRulesQueryKeys = {
  detail: (orgId: string | undefined) => orgQueryKeys.approvalRules(orgId),
}

export const orgCardApprovalRulesQueries = {
  detail: (orgId: string | undefined) =>
    queryOptions({
      queryKey: orgCardApprovalRulesQueryKeys.detail(orgId),
      queryFn: async () => {
        const data = await getCardApprovalRule(orgId!)
        // The legacy selector exposed only the first rule.
        return data.approvalRules[0] ?? null
      },
      enabled: Boolean(orgId),
      ...queryCacheOptions(),
    }),
}

export type PostCardApprovalRuleParams = {
  orgId: string
  body: UpsertCardApprovalRuleBody
}

export type DeleteCardApprovalRuleParams = {
  orgId: string
  approvalRuleId: string
}

export const orgCardApprovalRulesMutations = {
  post: () =>
    mutationOptions<
      PostCardApprovalRuleResponse,
      QueryError,
      PostCardApprovalRuleParams
    >({
      mutationFn: (params) => postCardApprovalRule(params.orgId, params.body),
    }),
  delete: () =>
    mutationOptions<
      DeleteCardApprovalRuleResponse,
      QueryError,
      DeleteCardApprovalRuleParams
    >({
      mutationFn: (params) =>
        deleteCardApprovalRule(params.orgId, params.approvalRuleId),
    }),
}

export const isCardApprovalRuleEnabled = (
  approvalRule: ApprovalRuleResponse | undefined | null,
): boolean => approvalRule?.type === ApprovalRuleType.Approver
